import {
  Icon,
  mergeStyles,
  MessageBar,
  MessageBarType,
  Spinner,
  SpinnerSize,
} from '@fluentui/react';
import * as React from 'react';

import { SubscriptionNode } from '../../../../Common/ConsumerModels/SubcriptionNode';
import * as Styled from '../../../../Common/Styles/attributeSubscriptions.styled';
import { CdmSubscriptions } from './CdmSubscriptions';
import { EgressOptionType } from '../../../../Common/CommonModels/EgressOptionTypeEnum';

type AddAttributeSubscriptionsFormProps = {
  formattedSubscriptionNodes: SubscriptionNode[];
  setFormattedSubscriptionNodes(subscriptionNodes: SubscriptionNode[]): void;
  filteredSubscriptionNodes: SubscriptionNode[];
  setFilteredSubscriptionNodes(subscriptionNodes: SubscriptionNode[]): void;
  isAttributeSubscriptionLoading: boolean;
  searchQuery: string;
  checkedAttributeCount: number;
  setCheckedAttributeCount(val: number): void;
  egressType: EgressOptionType;
};

export function TenantSubscriptions(props: AddAttributeSubscriptionsFormProps): React.ReactElement {
  const {
    formattedSubscriptionNodes,
    setFormattedSubscriptionNodes,
    filteredSubscriptionNodes,
    setFilteredSubscriptionNodes,
    isAttributeSubscriptionLoading,
    searchQuery,
    checkedAttributeCount,
    setCheckedAttributeCount,
    egressType
  } = props;

  const dropdownIconClass = mergeStyles({
    fontSize: 20,
    height: 20,
    width: 20,
    color: '#242424',
  });

  const onChangeDropdown = (tenantNode: SubscriptionNode, filteredTenantIndex: number): void => {

    // Set dropdown for formattedSubscriptionNodes tree
    const newFormattedSubscriptionNodes: SubscriptionNode[] = JSON.parse(
      JSON.stringify(formattedSubscriptionNodes) // deep copy
    );
    const formattedTenantIndex: number = tenantNode.pathFromRoot as unknown as number;
    const dropdown: boolean = newFormattedSubscriptionNodes[formattedTenantIndex].isDropdownExpand;
    newFormattedSubscriptionNodes[formattedTenantIndex].isDropdownExpand = !dropdown;

    setFormattedSubscriptionNodes(newFormattedSubscriptionNodes);

    // Set dropdown for filteredSubscriptionNodes tree
    const newFilteredSubscriptionNodes: SubscriptionNode[] = JSON.parse(
      JSON.stringify(filteredSubscriptionNodes) // deep copy
    );
    const filteredDropdown: boolean = newFilteredSubscriptionNodes[filteredTenantIndex].isDropdownExpand;
    newFilteredSubscriptionNodes[filteredTenantIndex].isDropdownExpand = !filteredDropdown;

    setFilteredSubscriptionNodes(newFilteredSubscriptionNodes);
  };

  const renderTenantTitleDropdown = (tenantNode: SubscriptionNode, filteredTenantIndex: number): JSX.Element => {
    return (
      <Styled.SingleTenantContainer>
        <Styled.TenantTextIconContainer>
          <Styled.TenantText>{tenantNode.name}</Styled.TenantText>
          {tenantNode.isDropdownExpand && (
            <Icon
              data-testid="contract-attribute-subscriptions"
              aria-label="Contract Attribute Subscriptions"
              iconName="ChevronUp"
              className={dropdownIconClass}
              onClick={() => onChangeDropdown(tenantNode, filteredTenantIndex)}
            />
          )}
          {!tenantNode.isDropdownExpand && (
            <Icon
              data-testid="expand-attribute-subscriptions"
              aria-label="Expand Attribute Subscriptions"
              iconName="ChevronDown"
              className={dropdownIconClass}
              onClick={() => onChangeDropdown(tenantNode, filteredTenantIndex)}
            />
          )}
        </Styled.TenantTextIconContainer>
        <Styled.TenantDivider />
      </Styled.SingleTenantContainer>
    );
  };

  return (
    <Styled.TenantSubscriptionsContainer>
    
      <Styled.TemporaryNotesContainer>
        <MessageBar messageBarType={MessageBarType.warning}>
          NOTE: All attributes designated as keys will be added automatically.
        </MessageBar>
        <MessageBar messageBarType={MessageBarType.warning}>
          NOTE: All requested attributes will be synchronized to all selected egress options across the subscription
          once approved.
        </MessageBar>
      </Styled.TemporaryNotesContainer>

      {!isAttributeSubscriptionLoading &&
        filteredSubscriptionNodes.map((tenantNode, filteredTenantIndex) => (
          <div key={tenantNode.pathFromRoot}>

            {renderTenantTitleDropdown(tenantNode, filteredTenantIndex)}

            {tenantNode.isDropdownExpand && 
              <CdmSubscriptions 
                formattedSubscriptionNodes={formattedSubscriptionNodes}
                setFormattedSubscriptionNodes={setFormattedSubscriptionNodes}
                filteredSubscriptionNodes={filteredSubscriptionNodes}
                setFilteredSubscriptionNodes={setFilteredSubscriptionNodes}
                isAttributeSubscriptionLoading={isAttributeSubscriptionLoading}
                searchQuery={searchQuery}
                checkedAttributeCount={checkedAttributeCount}
                setCheckedAttributeCount={setCheckedAttributeCount}
                filteredTenantIndex={filteredTenantIndex}
                egressType={egressType}
              />
            }
          </div>
        ))}

      {isAttributeSubscriptionLoading && <Spinner size={SpinnerSize.large} />}

      {!isAttributeSubscriptionLoading && filteredSubscriptionNodes.length === 0 && (
        <MessageBar messageBarType={MessageBarType.info}>
          Attributes not found for Egress Option and Environment
        </MessageBar>
      )}
    </Styled.TenantSubscriptionsContainer>
  );
}
  